const D = "1.0.0", G = {
  version: D,
  wallHeightFt: 8,
  // Edwin prices paint off the shed's footprint, not wall area:
  // a 10×10 is 100 sq ft × $3.85 = $385.
  paintableSqFt: (n) => n.w * n.l,
  models: [
    { id: "garden", name: "Garden Shed", description: "Window and workbench included" },
    { id: "barn", name: "Barn", description: "Gambrel roof — 4' loft included" },
    { id: "utility", name: "Utility / Standard", description: "Classic no-frills storage" }
  ],
  sizes: [
    { w: 8, l: 8 },
    { w: 8, l: 12 },
    { w: 10, l: 12 },
    { w: 10, l: 16 },
    { w: 12, l: 16 },
    { w: 12, l: 24 }
  ],
  pricing: {
    paintRatePerSqFtCents: 385,
    // $3.85 / sq ft of paintable area
    primerRatePerSqFtCents: 385,
    // same rate as paint today — change here if primer gets its own rate
    flooringRatePerSqFtCents: 100,
    // $1.00 / sq ft for upgraded flooring (client-confirmed)
    cinderblockRatePerSqFtCents: 110,
    // $1.10 / sq ft cinderblock leveling for unlevel sites (client-confirmed)
    anchorsPriceCents: 32500,
    // $325 flat for auger/anchor tie-downs (client-confirmed)
    rampPriceCents: 32500,
    // $325 flat for an entry ramp (client-confirmed)
    workbenchPriceCents: 12e3,
    // TODO(client): confirm workbench price ($120.00 placeholder)
    loftBaseDepthFt: 4,
    loftBasePriceCents: 2e4,
    // TODO(client): confirm loft base price ($200.00 placeholder, covers 4 ft depth)
    loftPerExtraFootCents: 4e3,
    // TODO(client): confirm per-extra-foot loft rate ($40.00/ft placeholder)
    shelvingPriceCents: 8600,
    // TODO(client): confirm shelving price ($86.00 placeholder)
    ventingCompletePriceCents: 12500,
    // Edwin-confirmed complete venting package price ($125.00)
    ventingSolarPriceCents: 4e4,
    // Edwin-confirmed solar venting package price ($400.00)
    windowPriceCents: 15500,
    // TODO(client): confirm 22×36 window price ($155.00 placeholder)
    architecturalShinglesPriceCents: 13900
    // TODO(client): confirm architectural shingle upgrade ($139.00 placeholder)
  },
  // Body/paint colors shown when the customer chooses the Paint Package (not
  // Primer). Client-confirmed names and hexes (Aug 2026) — the hex drives the
  // swatch and the id is what quotes record, so renaming is safe but changing
  // an id breaks any GHL field mapping keyed on the old value.
  paintColors: [
    { id: "p-autumn-gray", name: "Autumn Gray", hex: "#817F6E" },
    { id: "p-billiard-green", name: "Billiard Green", hex: "#305A4A" },
    { id: "p-black-magic", name: "Black Magic", hex: "#414040" },
    { id: "p-undercover", name: "Undercover", hex: "#5C5752" },
    { id: "p-bone-white", name: "Bone White", hex: "#E6D8C4" },
    { id: "p-brick-dust", name: "Brick Dust", hex: "#83423E" },
    { id: "p-bronzed-ivy", name: "Bronzed Ivy", hex: "#605849" },
    { id: "p-brown-clay", name: "Brown Clay", hex: "#C37C59" },
    { id: "p-chocolate-ripple", name: "Chocolate Ripple", hex: "#76604E" },
    { id: "p-classic-burgundy", name: "Classic Burgundy", hex: "#77393E" },
    { id: "p-coffee-kiss", name: "Coffee Kiss", hex: "#B19576" },
    { id: "p-commercial-white", name: "Commercial White", hex: "#EDECE6" },
    { id: "p-dover-gray", name: "Dover Gray", hex: "#848585" },
    { id: "p-gray-frost", name: "Gray Frost", hex: "#B8BFC2" },
    { id: "p-night-rendezvous", name: "Night Rendezvous", hex: "#66787E" },
    { id: "p-notorious", name: "Notorious", hex: "#BDA998" },
    { id: "p-red-gumball", name: "Red Gumball", hex: "#A63D3E" },
    { id: "p-rock-cliffs", name: "Rock Cliffs", hex: "#BFAA8D" },
    { id: "p-suddenly-sapphire", name: "Suddenly Sapphire", hex: "#006295" },
    { id: "p-sweet-dreams", name: "Sweet Dreams", hex: "#9BC7EA" },
    { id: "p-waves-of-grain", name: "Waves of Grain", hex: "#F1D3A9" }
  ],
  shingles: {
    // Client-supplied shingle colors (digital swatches, no images). Shown with
    // real shingle color names; the hex only drives the on-screen swatch.
    architecturalColors: [
      { id: "s-charcoal", name: "Charcoal", hex: "#45484B" },
      { id: "s-estate-gray", name: "Estate Gray", hex: "#7D8083" },
      { id: "s-desert-tan", name: "Desert Tan", hex: "#A67C5A" },
      { id: "s-brownwood", name: "Brownwood", hex: "#C19A6B" },
      { id: "s-driftwood", name: "Driftwood", hex: "#C2AD9A" }
    ],
    // 3-Tab shares the exact same color set as Architectural (distinct ids so
    // the quote records which shingle line the color belongs to).
    threeTabColors: [
      { id: "st-charcoal", name: "Charcoal", hex: "#45484B" },
      { id: "st-estate-gray", name: "Estate Gray", hex: "#7D8083" },
      { id: "st-desert-tan", name: "Desert Tan", hex: "#A67C5A" },
      { id: "st-brownwood", name: "Brownwood", hex: "#C19A6B" },
      { id: "st-driftwood", name: "Driftwood", hex: "#C2AD9A" }
    ]
  },
  venting: {
    // Flip to false to remove the "None" card — the two packages become the
    // only valid choices and one must still be explicitly selected.
    allowNone: !0
  },
  shelving: {
    allowQuantity: !0,
    // exposes a 1–maxQuantity picker (one per side)
    maxQuantity: 3
  },
  loft: {
    depthOptionsFt: [4, 6, 8]
  },
  // Base-package inclusions, centralized. Never scatter model conditionals
  // through UI components — everything reads from here.
  modelRules: {
    garden: { includes: ["window"] },
    barn: { includes: [{ item: "loft", spec: { depthFt: 4 } }] },
    utility: { includes: [] }
  }
};
function z(n, e) {
  return e ? E(n, e) : n;
}
function E(n, e) {
  if (e === void 0) return n;
  if (n !== null && e !== null && typeof n == "object" && typeof e == "object" && !Array.isArray(n) && !Array.isArray(e)) {
    const r = { ...n };
    for (const i of Object.keys(e))
      r[i] = E(
        n[i],
        e[i]
      );
    return r;
  }
  return e;
}
function u(n, e, r) {
  if (!e) return null;
  const i = n.modelRules[e];
  if (!i) return null;
  for (const t of i.includes)
    if (typeof t == "string") {
      if (t === r) return {};
    } else if (t.item === r)
      return { spec: t.spec };
  return null;
}
const h = (n) => `${n}-included`, g = (n) => n.includes("-upgrade");
function w(n, e, r) {
  var o;
  const i = u(r, e.model, n), t = e.selections[n];
  return i ? t && g(t.optionId) ? t : {
    optionId: h(n),
    included: !0,
    depthFt: (o = i.spec) == null ? void 0 : o.depthFt
  } : t ?? null;
}
const q = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }), l = (n) => q.format(n / 100), m = (n) => n.w * n.l;
function R(n, e, r) {
  var t;
  if (!e || !r || !n.basePrices) return 0;
  const i = `${r.w}x${r.l}`;
  return ((t = n.basePrices[e]) == null ? void 0 : t[i]) ?? 0;
}
const N = (n) => Math.min(n.w, n.l), f = (n, e) => Math.round(n.paintableSqFt(e, n.wallHeightFt));
function x(n, e) {
  const { loftBaseDepthFt: r, loftBasePriceCents: i, loftPerExtraFootCents: t } = n.pricing;
  return i + Math.max(0, e - r) * t;
}
function A(n, e) {
  return x(n, e) - n.pricing.loftBasePriceCents;
}
const v = {
  model: "Shed model & size",
  paint: "Paint",
  flooring: "Flooring",
  foundation: "Site leveling",
  workbench: "Workbench",
  loft: "Loft",
  shelving: "Shelving",
  venting: "Venting",
  window: "Window",
  delivery: "Delivery access",
  anchors: "Anchors",
  ramp: "Ramp",
  roofing: "Roofing",
  quote: "Quote"
}, T = [
  "paint",
  "roofing",
  "flooring",
  "foundation",
  "workbench",
  "loft",
  "shelving",
  "venting",
  "window",
  "delivery",
  "anchors",
  "ramp"
];
function k(n, e, r, i, t) {
  const o = i.dimensions, s = t.pricing;
  switch (n) {
    case "paint":
      return o ? e === "primer" ? s.primerRatePerSqFtCents * f(t, o) : e === "paint" ? s.paintRatePerSqFtCents * f(t, o) : 0 : 0;
    case "flooring":
      return e === "upgraded" && o ? s.flooringRatePerSqFtCents * m(o) : 0;
    case "foundation":
      return e === "unlevel" && o ? s.cinderblockRatePerSqFtCents * m(o) : 0;
    case "anchors":
      return e === "anchors" ? s.anchorsPriceCents : 0;
    case "ramp":
      return e === "ramp" ? s.rampPriceCents : 0;
    case "delivery":
      return 0;
    case "workbench":
      return e === "workbench" ? s.workbenchPriceCents : 0;
    case "loft":
      return e === "loft" ? x(t, r.depthFt ?? s.loftBaseDepthFt) : g(e) && r.depthFt != null ? A(t, r.depthFt) : 0;
    case "shelving":
      return e === "shelving" ? s.shelvingPriceCents * (r.quantity ?? 1) : 0;
    case "venting":
      return e === "complete" ? s.ventingCompletePriceCents : e === "solar" ? s.ventingSolarPriceCents : 0;
    case "window":
      return e === "window" ? s.windowPriceCents : 0;
    case "roofing":
      return e === "architectural" ? s.architecturalShinglesPriceCents : 0;
    default:
      return 0;
  }
}
function B(n, e, r, i) {
  switch (n) {
    case "paint":
      return e === "paint" ? "Paint Package" : e === "primer" ? "Primer Only" : "None — Unpainted";
    case "flooring":
      return e === "upgraded" ? "Upgraded Flooring" : "Standard Floor";
    case "foundation":
      return e === "unlevel" ? "Cinderblock leveling" : "Level site — no leveling";
    case "anchors":
      return e === "anchors" ? "Auger anchors" : "No anchors";
    case "ramp":
      return e === "ramp" ? "Ramp" : "No ramp";
    case "delivery":
      return e === "obstruction" ? "Possible delivery obstruction" : "Clear delivery access";
    case "workbench":
      return e === "none" ? "None" : "8' Workbench";
    case "loft":
      return e === "none" ? "No Loft" : `${r.depthFt ?? i.pricing.loftBaseDepthFt}' Loft`;
    case "shelving":
      return e === "shelving" ? "Standard Shelving" : "None";
    case "venting":
      return e === "complete" ? "Complete Venting Package" : e === "solar" ? "Solar Venting Package" : "None";
    case "window":
      return e === "none" ? "None" : "22×36 Window";
    case "roofing":
      return e === "architectural" ? "Architectural Shingles" : "Standard 3-Tab Shingles";
    default:
      return e;
  }
}
function $(n, e) {
  var i;
  return ((i = [
    ...n.paintColors,
    ...n.shingles.architecturalColors,
    ...n.shingles.threeTabColors
  ].find((t) => t.id === e)) == null ? void 0 : i.name) ?? e;
}
function b(n, e) {
  var r;
  return ((r = n.models.find((i) => i.id === e.model)) == null ? void 0 : r.name) ?? e.model ?? "";
}
function I(n, e, r, i) {
  const t = [B(n, e.optionId, e, i)];
  return e.color && t.push(`Color: ${$(i, e.color)}`), n === "shelving" && (e.quantity ?? 1) > 1 && t.push(`Qty ${e.quantity}`), n === "loft" && g(e.optionId) && t.push(`upgraded from included ${i.pricing.loftBaseDepthFt}' loft`), e.included && t.push(`Included with ${b(i, r)}`), t.join(" — ");
}
function L(n, e) {
  const r = [];
  if (n.model && n.dimensions) {
    const t = R(e, n.model, n.dimensions);
    r.push({
      stepId: "model",
      label: v.model,
      optionId: n.model,
      detail: `${n.dimensions.w}×${n.dimensions.l} ${b(e, n)}`,
      priceCents: t,
      price: l(t),
      included: !1
    });
  }
  for (const t of T) {
    const o = w(t, n, e);
    if (!o) continue;
    const s = !!o.included, c = s ? 0 : k(t, o.optionId, o, n, e);
    r.push({
      stepId: t,
      label: v[t],
      optionId: o.optionId,
      detail: I(t, o, n, e),
      priceCents: c,
      price: l(c),
      included: s
    });
  }
  const i = r.reduce((t, o) => t + o.priceCents, 0);
  return { lineItems: r, subtotalCents: i, totalCents: i };
}
const Q = L;
function V(n, e, r) {
  if (!n.model || !n.dimensions)
    throw new Error("Cannot build a quote payload before a model and size are chosen.");
  const i = L(n, e), t = n.dimensions;
  return {
    model: { id: n.model, name: b(e, n) },
    dimensions: {
      w: t.w,
      l: t.l,
      floorSqFt: m(t),
      paintableSqFt: f(e, t),
      shortestWallFt: N(t)
    },
    selections: i.lineItems,
    totals: {
      subtotalCents: i.subtotalCents,
      subtotal: l(i.subtotalCents),
      totalCents: i.totalCents,
      total: l(i.totalCents)
    },
    lead: { ...n.lead },
    meta: { createdAt: r, configuratorVersion: e.version }
  };
}
function F(n, e, r, i) {
  const t = [];
  switch (n) {
    case "paint": {
      e.optionId === "paint" && !e.color && t.push("Choose a paint color to continue.");
      break;
    }
    case "roofing": {
      (e.optionId === "architectural" ? i.shingles.architecturalColors : i.shingles.threeTabColors).length > 0 && !e.color && t.push("Choose a shingle color to continue.");
      break;
    }
    case "loft":
      break;
    case "shelving": {
      const o = e.quantity ?? 1;
      e.optionId === "shelving" && (o < 1 || o > i.shelving.maxQuantity) && t.push(`Shelving quantity must be between 1 and ${i.shelving.maxQuantity}.`);
      break;
    }
  }
  return t;
}
const _ = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, O = /^\d{5}(-\d{4})?$/;
function y(n) {
  const e = {};
  n.firstName.trim() || (e.firstName = "First name is required."), n.lastName.trim() || (e.lastName = "Last name is required."), n.email.trim() ? _.test(n.email.trim()) || (e.email = "Enter a valid email address.") : e.email = "Email is required.";
  const r = n.phone.replace(/\D/g, "");
  return n.phone.trim() ? (r.length < 10 || r.length > 11) && (e.phone = "Enter a valid phone number.") : e.phone = "Phone number is required.", n.zip.trim() ? O.test(n.zip.trim()) || (e.zip = "Enter a valid ZIP code.") : e.zip = "ZIP code is required.", e;
}
const p = [
  "model",
  "paint",
  "roofing",
  "flooring",
  "foundation",
  "workbench",
  "loft",
  "shelving",
  "venting",
  "window",
  "delivery",
  "anchors",
  "ramp",
  "quote"
], S = (n) => p.indexOf(n), Y = {
  model: "Choose your size.",
  paint: "Choose your paint package.",
  flooring: "Select the flooring for your shed.",
  foundation: "Is leveling needed at the shed site?",
  workbench: "Do you want a workbench installed?",
  loft: "Do you want a loft for your shed?",
  shelving: "Do you want shelving for your shed?",
  venting: "Choose your venting package.",
  window: "Do you want a window for your shed?",
  delivery: "Will anything obstruct delivery?",
  anchors: "Do you need auger anchors?",
  ramp: "Do you want a ramp for your shed?",
  roofing: "Choose your roofing style.",
  quote: "Your quote summary"
};
function C(n, e) {
  var r;
  return ((r = e.models.find((i) => i.id === n.model)) == null ? void 0 : r.name) ?? "this model";
}
function j(n, e, r) {
  var c;
  const i = e.dimensions, t = i ? `${i.w}×${i.l}` : "", o = r.pricing, s = (a, d = {}) => k(n, a, d, e, r);
  switch (n) {
    case "paint": {
      const a = s("paint");
      return [
        {
          id: "none",
          title: "None — Unpainted",
          specNote: "Bare exterior siding",
          priceCents: 0,
          priceLabel: l(0),
          art: "none"
        },
        {
          id: "paint",
          title: "Paint Package",
          specNote: "Primer + two finish coats in your color",
          priceCents: a,
          priceLabel: `${l(o.paintRatePerSqFtCents)}/sq ft — ${l(a)} for your ${t} shed`,
          requiresColor: !0,
          colorChoices: r.paintColors,
          art: "paint"
        }
      ];
    }
    case "flooring": {
      const a = s("upgraded");
      return [
        {
          id: "standard",
          title: "Standard Floor",
          specNote: "Plywood deck over pressure-treated runners",
          priceCents: 0,
          priceLabel: l(0),
          art: "floor"
        },
        {
          id: "upgraded",
          title: "Upgraded Flooring",
          specNote: "Heavy-duty tongue-and-groove decking",
          priceCents: a,
          priceLabel: `${l(o.flooringRatePerSqFtCents)}/sq ft — ${l(a)} for your shed`,
          art: "floor-upgraded"
        }
      ];
    }
    case "workbench":
      return u(r, e.model, n) ? [
        {
          id: h(n),
          title: "8' Workbench",
          specNote: "2 ft deep × runs the length of your shed",
          priceCents: 0,
          priceLabel: "Included — $0.00",
          included: !0,
          includedLabel: `✓ Included with ${C(e, r)}`,
          art: "workbench"
        }
      ] : [
        {
          id: "none",
          title: "No — no workbench",
          specNote: "Open shed, no workbench",
          priceCents: 0,
          priceLabel: l(0),
          art: "none"
        },
        {
          id: "workbench",
          title: "Yes — 8' Workbench",
          specNote: "2 ft deep × runs the length of your shed",
          priceCents: o.workbenchPriceCents,
          priceLabel: l(o.workbenchPriceCents),
          art: "workbench"
        }
      ];
    case "loft": {
      const a = u(r, e.model, n);
      if (a) {
        const d = ((c = a.spec) == null ? void 0 : c.depthFt) ?? o.loftBaseDepthFt;
        return [
          {
            id: h(n),
            title: `${d}' Loft`,
            specNote: "Overhead storage platform",
            priceCents: 0,
            priceLabel: "Included — $0.00",
            included: !0,
            includedLabel: `✓ Included: ${d}' Loft — ${C(e, r)}`,
            art: "loft"
          }
        ];
      }
      return [
        {
          id: "none",
          title: "No Loft",
          specNote: "Open ceiling",
          priceCents: 0,
          priceLabel: l(0),
          art: "none"
        },
        {
          id: "loft",
          title: "Loft",
          specNote: "Overhead storage platform",
          priceCents: o.loftBasePriceCents,
          priceLabel: l(o.loftBasePriceCents),
          art: "loft"
        }
      ];
    }
    case "shelving":
      return [
        {
          id: "none",
          title: "None",
          specNote: "No shelving",
          priceCents: 0,
          priceLabel: l(0),
          art: "none"
        },
        {
          id: "shelving",
          title: "Standard Shelving",
          specNote: r.shelving.allowQuantity ? `Wall-mounted shelf — up to ${r.shelving.maxQuantity}, one per side` : "Wall-mounted shelf unit",
          priceCents: o.shelvingPriceCents,
          priceLabel: `${l(o.shelvingPriceCents)} each`,
          art: "shelving"
        }
      ];
    case "venting": {
      const a = [];
      return r.venting.allowNone && a.push({
        id: "none",
        title: "None",
        specNote: "No venting package",
        priceCents: 0,
        priceLabel: l(0),
        art: "none"
      }), a.push(
        {
          id: "complete",
          title: "Complete Venting Package",
          specNote: "Gable vents + ridge vent for passive airflow",
          priceCents: o.ventingCompletePriceCents,
          priceLabel: l(o.ventingCompletePriceCents),
          art: "vent"
        },
        {
          id: "solar",
          title: "Solar Venting Package",
          specNote: "Solar-powered exhaust fan + intake vents",
          priceCents: o.ventingSolarPriceCents,
          priceLabel: l(o.ventingSolarPriceCents),
          art: "solar"
        }
      ), a;
    }
    case "window":
      return u(r, e.model, n) ? [
        {
          id: h(n),
          title: "22×36 Window",
          specNote: "Fixed-pane window with trim",
          priceCents: 0,
          priceLabel: "Included — $0.00",
          included: !0,
          includedLabel: `✓ Included with ${C(e, r)}`,
          art: "window"
        }
      ] : [
        {
          id: "none",
          title: "None",
          specNote: "No window",
          priceCents: 0,
          priceLabel: l(0),
          art: "none"
        },
        {
          id: "window",
          title: "22×36 Window",
          specNote: "Fixed-pane window with trim",
          priceCents: o.windowPriceCents,
          priceLabel: l(o.windowPriceCents),
          art: "window"
        }
      ];
    case "roofing": {
      const a = r.shingles.threeTabColors;
      return [
        {
          id: "three-tab",
          title: "Standard 3-Tab Shingles",
          specNote: "Stock shingles — pick a color below",
          priceCents: 0,
          priceLabel: l(0),
          requiresColor: a.length > 0,
          colorChoices: a,
          art: "shingles"
        },
        {
          id: "architectural",
          title: "Architectural Shingles",
          specNote: "Dimensional shingles — pick a color below",
          priceCents: o.architecturalShinglesPriceCents,
          priceLabel: l(o.architecturalShinglesPriceCents),
          requiresColor: !0,
          colorChoices: r.shingles.architecturalColors,
          art: "shingles-arch"
        }
      ];
    }
    case "foundation": {
      const a = s("unlevel");
      return [
        {
          id: "level",
          title: "No — leveling not needed",
          specNote: "Site is ready to set as-is",
          priceCents: 0,
          priceLabel: l(0),
          art: "none"
        },
        {
          id: "unlevel",
          title: "Yes — leveling needed",
          specNote: "Cinderblock leveling so the shed sits true",
          priceCents: a,
          priceLabel: `${l(o.cinderblockRatePerSqFtCents)}/sq ft — ${l(a)} for your ${t} shed`,
          art: "blocks"
        }
      ];
    }
    case "delivery":
      return [
        {
          id: "clear",
          title: "No — clear access",
          specNote: "Nothing blocking the path to the install spot",
          priceCents: 0,
          priceLabel: "No charge",
          art: "none"
        },
        {
          id: "obstruction",
          title: "Yes — there is an obstruction",
          specNote: "Fence headache board, narrow gate, low wires, or other obstacle — we will follow up",
          priceCents: 0,
          priceLabel: "No charge",
          art: "obstruction"
        }
      ];
    case "anchors":
      return [
        {
          id: "none",
          title: "No",
          specNote: "No anchors",
          priceCents: 0,
          priceLabel: l(0),
          art: "none"
        },
        {
          id: "anchors",
          title: "Yes — Auger anchors",
          specNote: "Ground auger anchors tie the shed down against wind",
          priceCents: o.anchorsPriceCents,
          priceLabel: l(o.anchorsPriceCents),
          art: "anchor"
        }
      ];
    case "ramp":
      return [
        {
          id: "none",
          title: "No Ramp",
          priceCents: 0,
          priceLabel: l(0),
          art: "none"
        },
        {
          id: "ramp",
          title: "Ramp",
          priceCents: o.rampPriceCents,
          priceLabel: l(o.rampPriceCents),
          art: "ramp"
        }
      ];
    default:
      return [];
  }
}
function P(n, e, r) {
  if (n === "model") return e.model !== null && e.dimensions !== null;
  if (n === "quote") return e.submitted;
  if (!e.model || !e.dimensions) return !1;
  const i = w(n, e, r);
  return i ? F(n, i, e, r).length === 0 : !1;
}
function H(n, e) {
  const r = n.dimensions;
  return r ? {
    floorSqFt: m(r),
    paintableSqFt: f(e, r),
    shortestWallFt: N(r)
  } : null;
}
function M(n = {}) {
  return {
    stepIndex: 0,
    maxStepReached: 0,
    // Prop-driven intake: host already knows the shed → Step 0 renders as a
    // read-only confirmation. NO other selection is ever pre-filled.
    model: n.initialModel ?? null,
    dimensions: n.initialDimensions ?? null,
    modelLocked: n.initialModel != null,
    dimensionsLocked: n.initialDimensions != null,
    selections: {},
    lead: { firstName: "", lastName: "", email: "", phone: "", zip: "" },
    leadErrors: {},
    advanceError: null,
    editReturnIndex: null,
    submitted: !1
  };
}
const W = "Please select an option to continue — choose 'None' if you don't want this add-on.", U = "Please select a shed model and size to continue.";
function Z(n) {
  return function(r, i) {
    switch (i.type) {
      case "SELECT_MODEL":
        return r.modelLocked || r.model === i.model ? r.model === i.model ? { ...r, advanceError: null } : r : { ...r, model: i.model, advanceError: null };
      case "SELECT_SIZE":
        return r.dimensionsLocked ? r : { ...r, dimensions: { ...i.dimensions }, advanceError: null };
      case "SELECT_OPTION": {
        const t = r.selections[i.stepId], o = (t == null ? void 0 : t.optionId) === i.optionId, s = {
          optionId: i.optionId,
          // Re-selecting the same option keeps its sub-choices; switching
          // options clears them so nothing carries over silently.
          depthFt: i.depthFt ?? (o ? t == null ? void 0 : t.depthFt : void 0),
          color: o ? t == null ? void 0 : t.color : void 0,
          quantity: o ? t == null ? void 0 : t.quantity : i.stepId === "shelving" && i.optionId === "shelving" ? 1 : void 0
        };
        return {
          ...r,
          selections: { ...r.selections, [i.stepId]: s },
          advanceError: null
        };
      }
      case "SELECT_COLOR": {
        const t = r.selections[i.stepId];
        return t ? {
          ...r,
          selections: {
            ...r.selections,
            [i.stepId]: { ...t, color: i.colorId }
          },
          advanceError: null
        } : r;
      }
      case "SET_QUANTITY": {
        const t = r.selections[i.stepId];
        if (!t) return r;
        const o = Math.min(Math.max(1, i.quantity), n.shelving.maxQuantity);
        return {
          ...r,
          selections: { ...r.selections, [i.stepId]: { ...t, quantity: o } },
          advanceError: null
        };
      }
      case "ADVANCE_STEP": {
        const t = p[r.stepIndex];
        if (t === "quote") return r;
        if (!P(t, r, n)) {
          let c = t === "model" ? U : W;
          const a = w(t, r, n);
          return a && (c = F(t, a, r, n)[0] ?? c), { ...r, advanceError: c };
        }
        let o = Math.min(r.stepIndex + 1, p.length - 1), s = r.editReturnIndex;
        return s != null && p.slice(0, s).every(
          (a) => P(a, r, n)
        ) && (o = s, s = null), {
          ...r,
          stepIndex: o,
          maxStepReached: Math.max(r.maxStepReached, o),
          advanceError: null,
          editReturnIndex: s
        };
      }
      case "BACK_STEP":
        return r.stepIndex === 0 ? r : { ...r, stepIndex: r.stepIndex - 1, advanceError: null };
      case "EDIT_STEP": {
        const t = S(i.stepId);
        return t < 0 ? r : {
          ...r,
          stepIndex: t,
          editReturnIndex: S("quote"),
          advanceError: null
        };
      }
      case "SET_LEAD_FIELD": {
        const t = { ...r.leadErrors };
        return delete t[i.field], {
          ...r,
          lead: { ...r.lead, [i.field]: i.value },
          leadErrors: t
        };
      }
      case "BLUR_LEAD_FIELD": {
        const t = y(r.lead)[i.field], o = { ...r.leadErrors };
        return t ? o[i.field] = t : delete o[i.field], { ...r, leadErrors: o };
      }
      case "SUBMIT_ATTEMPT":
        return { ...r, leadErrors: y(r.lead) };
      case "SUBMIT_SUCCESS":
        return { ...r, submitted: !0, advanceError: null };
      case "RESET":
        return M({
          initialModel: r.modelLocked ? r.model ?? void 0 : void 0,
          initialDimensions: r.dimensionsLocked ? r.dimensions ?? void 0 : void 0
        });
      default:
        return r;
    }
  };
}
export {
  D as CONFIGURATOR_VERSION,
  U as MSG_SELECT_MODEL,
  W as MSG_SELECT_TO_CONTINUE,
  T as PRICED_STEPS,
  Y as STEP_HEADINGS,
  v as STEP_LABELS,
  p as STEP_ORDER,
  R as basePriceCents,
  V as buildQuotePayload,
  L as computeQuote,
  M as createInitialState,
  G as defaultConfig,
  H as derivedDimensions,
  m as floorSqFt,
  l as formatCents,
  w as getEffectiveSelection,
  u as getInclusion,
  j as getStepOptions,
  h as includedOptionId,
  P as isStepComplete,
  g as isUpgradeOptionId,
  x as loftPriceCents,
  A as loftUpgradeDeltaCents,
  z as mergeConfig,
  k as optionPriceCents,
  B as optionTitle,
  f as paintableSqFt,
  Q as priceQuote,
  Z as reduce,
  N as shortestWallFt,
  S as stepIndexOf,
  y as validateLead,
  F as validateSelection
};
//# sourceMappingURL=core.js.map
